@import '../../assets/styles/components.css';

:host {
  @apply fixed inset-0 items-center justify-center opacity-0 overflow-y-hidden z-0;

  .modal {
    @apply flex flex-col bg-neutral-lightest max-w-screen-sm rounded w-full max-h-[90vh] text-neutral-darkest z-[52];
  }

  &([open]) {
    @apply opacity-100 z-50;
  }

  .backdrop {
    @apply fixed bg-neutral-darkest m-0 opacity-70 rounded-none z-[51];
    @apply h-full max-h-full max-w-full w-full;
  }

  .modal-body-bottom-el,
  .modal-body-top-el {
    @apply h-4;
  }

  .modal-body-wrapper {
    @apply bg-neutral-lightest min-h-[4rem] overflow-auto;
    @apply px-4;

    &.mask-top {
      --mask: linear-gradient(to bottom, transparent, #000 1.75rem);
      -webkit-mask-image: var(--mask);
      mask-image: var(--mask);
    }

    &.mask-bottom {
      --mask: linear-gradient(to top, transparent, #000 1.75rem);
      -webkit-mask-image: var(--mask);
      mask-image: var(--mask);
    }

    &.mask-bottom.mask-top {
      --mask: linear-gradient(180deg, transparent 0, #000 1.75rem, #000 calc(100% - 1.75rem), transparent);
      -webkit-mask-image: var(--mask);
      mask-image: var(--mask);
    }
  }

  .modal-footer-wrapper {
    @apply bg-neutral-light rounded-b;
    @apply px-4 py-3;
    @apply border-t border-secondary-100;
  }

  .modal-header-wrapper {
    @apply bg-neutral-lightest flex font-semibold items-center leading-6 rounded-t text-lg;
    @apply p-4;
    @apply border-b border-secondary-100;
    abds-icon.decorative-icon {
      @apply first:mr-1;
    }

    .close-button {
      @apply leading-[0] ml-auto rounded-sm text-secondary-400;
      @apply focus:outline-none focus:ring;
    }

    &.danger {
      @apply text-danger;
    }
  }
}
